import React from "react";
import { AppRouteURI, AppRoutingRoles } from "router/RoleBasedAccess";
import App from "../app/App";
import SettingsContainer from "./SettingsContainer";
export default function () {
  const { isProtected, checkRoles } = {
    ...AppRoutingRoles[AppRouteURI.SETTINGS],
  };
  return (
    <App isProtected={isProtected} checkRoles={checkRoles}>
      <SettingsContainer />
    </App>
  );
}
